import { Link, useParams } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { PropertyAkteWorkspace } from './AkteRegisterPage';

export function GlobalPropertyAktePage() {
  const { propertyId } = useParams({ from: '/_admin/akte/$propertyId' });
  return (
    <>
      <Link
        to="/akte"
        className="text-ink-soft hover:text-ink mb-5 inline-flex items-center gap-2 text-sm font-medium"
      >
        <ArrowLeft size={16} aria-hidden />
        Zur Aktenübersicht
      </Link>
      <PropertyAkteWorkspace propertyId={propertyId} />
    </>
  );
}
